import http from "./apiClient";

// TODO(backend): Wire this to the final generic/contact request endpoint once
// ContactRequestsAdmin is implemented. These requests must not use mutation-requests.
export const createContactRequest = (payload) => http.post("/contact-requests", payload);
